import PropTypes from 'prop-types';

export default function OutlineForecast(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <rect height="7" width="4" rx="1" stroke={color} strokeWidth={strokeWidth} x="1.102" y="9" />
            <rect height="11" width="4" rx="1" stroke={color} strokeWidth={strokeWidth} x="8.102" y="5" />
            <rect height="13" width="4" rx="1" stroke={color} strokeWidth={strokeWidth} x="15.102" y="3" />
            <path
                d="m14.878 13.553 4-2M14.878 15.553l4-2M14.878 11.553l4-2M14.878 9.553l4-2M14.878 7.553l4-2M14.878 5.553l4-2"
                stroke={color}
            />
        </svg>
    );
}

OutlineForecast.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
